export const getClosestValue = (
  acceptedValues: Array<number>,
  value: number,
): number =>
  acceptedValues.reduce((prev, curr) =>
    Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev,
  );
